export default function indexById(arr, key = "id") {
  return arr.reduce((all, item) => {
    const idKey = typeof key === "function" ? key(item) : item[key];

    return Object.assign(all, { [idKey]: item });
  }, {});
}
